import { useMemo, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectCommunityWatchlists } from '../selectors/watchList'
import { Watchlist_Type } from '../proto/generated/watchlist'

export const useAdminScreenerAccess = () => {
    const communityWatchlists = useSelector(selectCommunityWatchlists)
    return (shareId: string | undefined) => {
        if (!communityWatchlists || communityWatchlists.length === 0) {
            return false
        }
        const srcWatchlist = communityWatchlists?.find((wl) => wl.shareId === shareId)
        return (srcWatchlist?.type !== Watchlist_Type.SCREENER)
    }
}
